import axios from 'axios';
import Cookies from 'js-cookie';
import type { AxiosRequestConfig } from 'axios';

const mode = import.meta.env.MODE;
const rawBaseUrl = import.meta.env.VITE_API_URL || '';
const isDevelopment = mode === 'development';
const API_BASE_URL = !isDevelopment && rawBaseUrl.startsWith('http://')
  ? rawBaseUrl.replace('http://', 'https://')
  : rawBaseUrl;

// Criar instância do axios
export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token automaticamente
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('auth_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para lidar com respostas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token inválido ou expirado
      Cookies.remove('auth_token');
      Cookies.remove('user_data');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Função genérica para requisições tipadas
export async function fetcher<T = unknown>(config: AxiosRequestConfig): Promise<T> {
  const response = await api.request<T>(config);
  return response.data;
}

export default api; 
